export default __webpack_public_path__ + "static/media/sale.73302bac.svg";